module.exports = __webpack_public_path__ + "static/media/selfesteem-intro.5558a031.svg";